import { render } from "./expertreportstable.vue?vue&type=template&id=74e3cbbd&scoped=true"
import script from "./expertreportstable.vue?vue&type=script&lang=js"
export * from "./expertreportstable.vue?vue&type=script&lang=js"

import "./expertreportstable.vue?vue&type=style&index=0&id=74e3cbbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e3cbbd"]])

export default __exports__